import {
  MAT_COLORS,
  getSupportedMattingColors,
  type MatColorKey,
} from '@mixtiles/web-backend-shared'
import { experimentManager } from '../services/ExperimentManager/ExperimentManager'

const MAT_COLOR_KEYS = new Set(
  Object.keys(MAT_COLORS).map((key) => key.toUpperCase())
)
const COLOR_TO_KEY_MAP: Map<string, MatColorKey> = new Map(
  Object.entries(MAT_COLORS).map(([key, value]) => [value, key as MatColorKey])
)

export function normalizeMatColorToKey(input: string): MatColorKey {
  const trimmed = input.trim()
  const asUpperKey = trimmed.toUpperCase() as MatColorKey
  if (MAT_COLOR_KEYS.has(asUpperKey)) {
    return asUpperKey
  }
  if (trimmed.startsWith('#')) {
    const hexColor = trimmed.toUpperCase()
    const key = COLOR_TO_KEY_MAP.get(hexColor)
    if (key) {
      return key
    }
  }
  throw new Error(`Invalid matting color: ${input}`)
}

export function getMatColorValue(colorKey: MatColorKey): string {
  const isWithDeprecatedColors = experimentManager.isEnabled(
    'deprecated-colored-matting'
  )
  const supportedColors = getSupportedMattingColors(isWithDeprecatedColors)
  const colorValue = supportedColors[colorKey]
  return colorValue || MAT_COLORS.WHITE
}

export function getMatColorIndex(colorName: MatColorKey | string): number {
  return Object.keys(MAT_COLORS).indexOf(colorName as string)
}
